import { useQuery } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';

import { getLessonsStatsQuery } from '../graphql/queries';

export default function useLessonsStats({ courseId, groupId }) {
  const { data, loading, error } = useQuery(getLessonsStatsQuery, {
    variables: { courseId, groupId },
    skip: !courseId || !groupId,
    fetchPolicy: 'cache-and-network',
  });
  const lessonsStats = data?.lessonsStats;

  return {
    loading,
    error: getErrorMessage({ error }),
    lessonsStats,
  };
}
